export enum SmartCaptchaLanguages {
  Ru = 'ru',
  En = 'en',
  Be = 'be',
  Kk = 'kk',
  Tt = 'tt',
  Uk = 'uk',
  Uz = 'uz',
  Tr = 'tr',
}

export enum SmartCaptchaShieldPositions {
  TopLeft = 'top-left',
  CenterLeft = 'center-left',
  BottomLeft = 'bottom-left',
  TopRight = 'top-right',
  CenterRight = 'center-right',
  BottomRight = 'bottom-right',
}

export enum SmartCaptchaEvents {
  ChallengeVisible = 'challenge-visible',
  ChallengeHidden = 'challenge-hidden',
  NetworkError = 'network-error',
  Success = 'success',
  TokenExpired = 'token-expired',
  JavaScriptError = 'javascript-error',
}

export interface SmartCaptchaRenderParams {
  sitekey: string;
  callback?: CallbackFunction;
  hl?: SmartCaptchaLanguages;
  test?: boolean;
  webview?: boolean;
  invisible?: boolean;
  shieldPosition?: SmartCaptchaShieldPositions;
  hideShield?: boolean;
}

type CallbackFunction = (...params: any) => void;
type UnsubscribeFunction = () => void;
type WidgetId = number;

export interface SmartCaptchaGlobalObject {
  render: (container: HTMLElement | string, params: SmartCaptchaRenderParams) => WidgetId;
  destroy: (widgetId: WidgetId | undefined) => void;
  reset: (widgetId: WidgetId | undefined) => void;
  execute: (widgetId: WidgetId | undefined) => void;
  subscribe: (
    widgetId: WidgetId | undefined,
    event: SmartCaptchaEvents,
    callback: CallbackFunction,
  ) => UnsubscribeFunction;
}

export interface SmartCaptchaInitData {
  globalObject: SmartCaptchaGlobalObject;
}

export enum SmartCaptchaProcesses {
  LoginForm,
  SearchProducts,
}
